import React from "react";
import { Phone, MessageSquare, Mail } from "lucide-react";
import { PG_PHONE_TEL, PG_EMAIL } from "../lib/api";

export default function StickyContact() {
  const items = [
    {
      id: "call",
      label: "Call Now",
      href: `tel:${PG_PHONE_TEL}`,
      icon: Phone,
      testid: "sticky-call-btn",
    },
    {
      id: "text",
      label: "Text Us",
      href: `sms:${PG_PHONE_TEL}`,
      icon: MessageSquare,
      testid: "sticky-text-btn",
    },
    {
      id: "email",
      label: "Email",
      href: `mailto:${PG_EMAIL}`,
      icon: Mail,
      testid: "sticky-email-btn",
    },
  ];

  return (
    <div
      data-testid="sticky-contact-widget"
      className="fixed bottom-6 right-6 z-50 flex flex-col gap-3"
    >
      {items.map(({ id, label, href, icon: Icon, testid }) => (
        <a
          key={id}
          href={href}
          data-testid={testid}
          className="group inline-flex items-center justify-end gap-3 rounded-full bg-[#0A1128] text-white shadow-[0_12px_30px_rgba(10,17,40,0.25)] hover:bg-[#172346] transition-all duration-300 pl-5 pr-4 py-3"
          aria-label={label}
        >
          <span className="max-w-0 overflow-hidden opacity-0 transition-all duration-300 group-hover:max-w-[120px] group-hover:opacity-100 whitespace-nowrap text-sm font-medium">
            {label}
          </span>
          <span className="h-9 w-9 inline-flex items-center justify-center rounded-full bg-[#D4AF37] text-[#0A1128]">
            <Icon size={18} strokeWidth={2} />
          </span>
        </a>
      ))}
    </div>
  );
}
